import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Panel, PanelHeader, PanelBody, PanelFooter } from './../../components/panel/panel.jsx'; 
import { toast } from 'react-toastify'; 
import axios from 'axios'
import Pagination from '../../components/pagination/pagination.jsx';
import Modal from 'react-modal';
import moment from 'moment/moment.js';
import AccountForm from './account.jsx'; 
import ModalWithProceed from '../../components/prompt/ModalWithProceed.jsx';
import { isEmpty } from '../../helper/helper.js';

function AccountList({ props = {} }) {

  const [dataTable, setDataTable] = useState([])
  const [state, setState] = useState({});
  const [formData, setFormData] = useState({ currentPage: 1, rowsPerPage: 50 });
  const [formIsOpen, setIsOpen] = useState(false);
  const [promptDeleteIsOpen, setPromptDeleteIsOpen] = useState(false);
  const [modalUid, setModalUid] = useState('')


  const handleOnChangeInputText = (e) => {
    const { name, value } = e.target
    setState(prevState => ({
      ...prevState,
      [name]: value
    }))
  }

  const onChangePageHandler = async (page) => {
    setFormData(prevState => ({ ...prevState, currentPage: page }))
    await refreshTable(page)
  }

  const onChangePageSelectHandler = async (e) => {
    setFormData(prevState => ({ ...prevState, rowsPerPage: e.target.value }))
    await refreshTable(state.currentPage, e.target.value)
  }

   const confirmDelete = async() => { 
      setPromptDeleteIsOpen(false)
    
      // if (isEmpty(formData.id)) {
      //   return
      // }
   
  
      await axios.delete(`${window.API_HOST}/v1/account/${formData.id}`)
        .then(res => {
          const data = res.data;
   
          toast.success(`Success delete Account ${formData.name}`)
          refreshTable()
  
        }).catch(err => {
          toast.error( err.response?.data?.error ?? `Can't delete ${formData.name}`)
  
        })  
    }

  const refreshTable = async (_page = formData.currentPage, _size = formData.rowsPerPage) => {

    let params = {
      page: _page ?? formData.currentPage,
      size: _size ?? formData.rowsPerPage,
      referenceNum: state.reffNum ?? '',
    }

    for (var key in params) {
      if (isEmpty(params[key])) {
        delete params[key]
      }
    }

    await axios.get(`${window.API_HOST}/v1/account`, {params})
      .then(res => {
        setDataTable(res.data?.data ?? [])
        setFormData( prevState => ({
          ...prevState,
          totalRows: res.data.meta.total
        }))

      }).catch(err => {

      })
  }

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-10%',
      transform: 'translate(-50%, -50%)',
    },
  };

  const openAccountForm = async (uid, e) => {
    e.preventDefault();
    
    setModalUid(uid)
    setIsOpen(true)
  }


  const searchForm = async () => {
    await refreshTable(1)
  }

  useEffect(() => { 
    searchForm() 
  }, []) // eslint-disable-line react-hooks/exhaustive-deps


  return (
    <div>
      <ol className="breadcrumb float-xl-end">
        <li className="breadcrumb-item"><Link to="/home"><i className='fa fa-home'></i> Home</Link></li>
      </ol>
      <h1 className="page-header">Account <small></small></h1>
      <Panel>
        <PanelHeader noButton>Account List</PanelHeader>
        <PanelBody>
          <div className='row'>
            <div className='col-sm-4'>
              <div className="form-group row mb-1">
                <label className="col-sm-3 col-form-label">Account Code</label>
                <div className="col-sm-9">
                  <input type="text" name="reffNum" value={state.reffNum ?? ""} onChange={handleOnChangeInputText} placeholder='Account Code / Name' className="form-control form-control-sm" />
                </div>
              </div>
              <div className="form-group row my-2">
                <label className="col-sm-3 col-form-label">&nbsp;</label>
                <div className="col-sm-8">
                  <button type="button" className="btn btn-sm btn-primary me-2" onClick={searchForm}><span className="fa fa-sm fa-search"></span> Search</button>
                  <button type="button" className="btn btn-sm btn-primary me-2" onClick={()=>{}}><span className="fa fa-sm fa-download" ></span> Download</button>
                  <button type="button" className="btn btn-sm btn-primary me-2" onClick={(e) => {openAccountForm(null, e)}}><span className="fa fa-plus-circle fa-sm"></span> New</button>
                </div>
              </div>
            </div>
          </div>
        </PanelBody>
      </Panel>
      <Panel>
        <PanelBody>
          <div className="table table-hover mb-0 text-dark">
            <table className="table table-sm table-hover table-striped mb-0 text-dark">
              <thead className='bg-lime-400 fw-bold'>
                <tr>
                  <th className='w-20px'>No.</th>
                  <th>Account</th>
                  <th>Name</th>
                  <th>Address</th>
                  <th>Province - City</th>
                  <th>Active</th>
                  <th>Last Update</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {dataTable.map((val, key) => {
                  return (
                    <tr className='fs-8 fw-light' key={key}>
                      <td>{((formData.currentPage - 1) * formData.rowsPerPage) + (key + 1)}.</td>
                      <td>{val.acc_code}</td>
                      <td>{val.acc_name}</td>
                      <td>{val.acc_address}</td>
                      <td>{val.acc_province_name} - {val.acc_city_name}</td>
                      <td>{val.active ? 'YES': 'NO'}</td>
                      <td>{moment(val.updated_at).format('YYYY-MM-DD HH-mm:ss')}</td>
                      <td><button className='btn btn-xs'><i className='fa fa-pen-to-square' onClick={(e)=>{openAccountForm(val.uid, e)}}></i></button> <button className='btn btn-xs'><i className='fa fa-trash text-danger' onClick={() => {
                        setFormData(prevState=>({
                          ...prevState,
                          name: val.acc_name,
                          id: val.uid
                        }))
                        setPromptDeleteIsOpen(true);
                        }}></i></button></td>
                    </tr>)
                })}
              </tbody>
            </table>
          </div>
        </PanelBody>
        <PanelFooter>
          <div className='row'>
            <div className="col-sm-12">
              <Pagination
                currentPage={formData.currentPage ?? 1}
                totalRows={formData.totalRows ?? 1}
                pageSize={formData.rowsPerPage ?? 50}
                onPageChange={onChangePageHandler}
                selectedPageHandler={onChangePageSelectHandler}
              />
            </div>
          </div>
        </PanelFooter>
        <div>
          <Modal
            isOpen={formIsOpen}
            onAfterOpen={() => { }}
            onRequestClose={() => setIsOpen(false)}
            style={customStyles}
            ariaHideApp={false}  >
            <AccountForm props={{
              uid: modalUid, cancelAction: () => {
                setIsOpen(false)
              }
            }} />
          </Modal>

          <ModalWithProceed header={false} show={promptDeleteIsOpen} close={() => { setPromptDeleteIsOpen(false) }} proceed={confirmDelete}>
          Do you want to delete <strong>{formData.name}</strong> ?
        </ModalWithProceed>
        </div> 
      </Panel>

    </div>
  )
}



export default AccountList;